<template>
  <el-dialog
    :title="(Type == 'Create' ? l('新增') : l('管理')) + '优选好商'"
    v-if="DialogVisible"
    :visible.sync="DialogVisible"
    width="750px"
    class="large-padding-dialog"
    :close-on-click-modal="false"
    :before-close="Hide"
  >
    <el-form
      :model="DialogFormData"
      ref="DialogFormData"
      :rules="dialogRules"
      :class="[{ View: Type == 'View' }]"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-row>
            <el-form-item :label="l('类型')" prop="tag_id">
              <el-select
                v-model="DialogFormData.tag_id"
                :disabled="Type == 'View'"
              >
                <el-option
                  v-for="item in tagList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item :label="l('名称')" prop="name">
              <el-input
                v-model="DialogFormData.name"
                placeholder="请输入名称"
                :disabled="Type == 'View'"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="优先级" prop="order_index">
              <el-input-number
                v-model="DialogFormData.order_index"
                :step="1"
                step-strictly
                :disabled="Type == 'View'"
              ></el-input-number>
            </el-form-item>
          </el-row>
        </el-col>

        <el-col :span="12">
          <ResourceUpLoad
            label="logo"
            prop="logo"
            usage="good_business"
            :initResourceUrl.sync="DialogFormData.logo"
            :disabled="Type == 'View'"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="简介" prop="description">
          <el-input
            type="textarea"
            :rows="5"
            v-model="DialogFormData.description"
            :disabled="Type == 'View'"
          ></el-input>
        </el-form-item>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{l("取 消")}}</el-button>

      <el-button
        v-if="
          Type == 'View' &&
          $store.getters.checkPermission('website_config.edit')
        "
        type="warning"
        @click="Type = 'Edit'"
        >{{l("修 改")}}</el-button
      >
      <el-button
        v-if="Type == 'Create' || Type == 'Edit'"
        type="primary"
        @click="submitForm"
        >{{l("确 定")}}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "CreateOrEditAdminGoodBusiness",
  mixins: [dialogMixin],
  props: ["tagList"],
  data() {
    return {
      DialogFormData: {
        id: null,
        name: "",
        logo: "",
        description: "",
        tag_id: "",
        order_index: 0,
      },
      dialogRules: {
        name: [{ required: true, message: this.l("请输入") + this.l("名称"), trigger: "blur" }],
        logo: [{ required: true, message: "请上传logo", trigger: "blur" }],
        tag_id: [{ required: true, message: this.l("请选择") + this.l("类型"), trigger: "blur" }],
        order_index: [
          { required: true, message: "请选择优先级", trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    submitForm() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }

        if (this.Type == "Create") {
          this.axios
            .post(`/api/admin_good_business/`, this.DialogFormData)
            .then((data) => {
              this.$emit("submitDialog");
              this.Hide();
            });
        } else {
          this.axios
            .put(
              `/api/admin_good_business/${this.DialogFormData.id}/`,
              this.DialogFormData
            )
            .then((data) => {
              this.$emit("submitDialog");
              this.Hide();
            });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
